module.exports = __webpack_public_path__ + "img/mobile-mapping-documentation.74640c84.jpg";